<template>
  <div id="app">
    <router-view v-if="!preloading" />
  </div>
</template>

<style lang="scss">
body {
  background-color: #ebecf0;
}

#app {
  font-family: Roboto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #ebecf0;
  height: 100vh;
}

.el-message {
  font-family: Roboto;
}
</style>

<script>
import { mapActions, mapState } from 'vuex';
import { Message } from 'element-ui';
import { isAuthenticated, redirectToSSO } from '@/api/workflow';

export default {
  computed: {
    ...mapState({
      preloading: state => state.identity.preloading
    })
  },
  methods: {
    ...mapActions(['preloadUserStatus'])
  },
  mounted() {
    this.preloadUserStatus().catch(err => {
      if (err?.response?.status === 401) {
        localStorage.removeItem('produce-token');
        redirectToSSO();
      } else {
        Message.error('Server error: ' + err.message);
      }
    });
  }
};
</script>
